import { formatDisplayPrice } from '../../../../../../../utils/math/formatDisplayPrice';
import { timeUnitMap } from "../../../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/FTFCBoxes";

export function parseOrbNotificationDetails(notification) {
  const setupTemplate = notification.statusDetails.setupTemplate;
  const setupString =
    'ORB-' +
    setupTemplate.candleDuration +
    timeUnitMap[setupTemplate.timeUnit];

  return {
    tactic: setupString,
    price: formatDisplayPrice(notification.statusDetails.triggerPrice),
  };
}

// const example = {
//   messageType: 'alertNotification',
//   notificationId: 1645477806924,
//   notificationDetails: {
//     updateType: 'SETUP_TRIGGERED',
//     notificationType: 'TRADE_PLAN_UPDATE',
//     TRADE_PLAN: { type: 'BASIC_TRADING_SYSTEM', id: 1, symbol: 'XYZ' },
//   },
//   status: 'TACTIC_TRIGGERED',
//   statusDetails: {
//     pluginTemplate: {
//       candleDuration: 1,
//       timeUnit: 'MINUTES',
//       candle: {
//         high: 101.0,
//         low: 99.0,
//         open: 100.0,
//         close: 100.0,
//         candleSymbol: 'XYZ',
//         candleStartTimeStamp: 1641110640000,
//         duration: '1min',
//       },
//     },
//     triggerPrice: 100.0,
//     tradeDirection: 'LONG',
//     tacticName: 'ORB',
//     symbol: 'XYZ',
//   },
//   date: '2022-02-21T16:10:07.477-0500',
//   timestamp: '1645477807480',
// };
